















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { GamePlayer } from '@/class/gamePlayer'
import { RoleId } from '@/enum'
import { StatusIconsComponentInterface } from './StatusIcons.vue'
import Memo from './Memo.vue'
import StatusIcons from './StatusIcons.vue'
import Card from '@/components/Common/Card/Card.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'

export interface PlayerListItemActionComponentInterface {
  game: Game
  playerSelf?: GamePlayer;
  playerId: string;
  statusIconsData: StatusIconsComponentInterface
  showsRole: boolean
  isGallary: boolean
  inSelectTime: boolean
  inVoteTime: boolean
  isSelected: boolean
  isVoted: boolean
}

@Component({
  components: {
    Memo,
    StatusIcons,
    Card,
    BtnSquare,
  }
})
export default class PlayerListItemAction extends Vue {
  @Prop() data!: PlayerListItemActionComponentInterface;

  get game() {
    return this.data.game
  }

  get playerSelf() {
    return this.data.playerSelf
  }

  get player() {
    return this.game.gamePlayerOf[this.data.playerId]
  }

  get showsPoliceButton(): boolean {
    return this.data.game.isDay
    && this.playerSelf?.id !== this.player.id
    && this.playerSelf?.selfAppointedRoleId === RoleId.police
    && !this.playerSelf?.isDead
    && !this.data.isGallary
  }

  get showsInvestigatorButton(): boolean {
    return this.data.game.isDay
    && this.playerSelf?.id !== this.player.id
    && this.playerSelf?.selfAppointedRoleId === RoleId.investigator
    && !this.playerSelf?.isDead
    && !this.data.isGallary
  }

  get showsSelectButton(): boolean {
    if (this.data.isGallary) return false

    if (!this.data.inSelectTime) return false

    if (!this.playerSelf) return false

    if (this.playerSelf.id === this.player.id) return false

    if (this.player.isDead) return false

    if (this.playerSelf.roleId === RoleId.doctor
     || this.playerSelf.roleId === RoleId.dancer
     || this.playerSelf.roleId === RoleId.prostitute) {
      if (this.playerSelf.lastNightSelectedPlayerId === this.player.id) {
        return false
      }
    }

    return true
  }

  get showsVoteButton(): boolean {
    if (this.data.isGallary) return false
    
    if (!this.data.inVoteTime) return false

    if (this.playerSelf?.id === this.player.id) return false

    if (this.player.isDead) return false

    if (this.game.roomFinalVotePlayerIds.length === 0) return true

    if (this.game.roomFinalVotePlayerIds.some(id => id === this.player.id)) return true

    return false
  }

  get isTurnEnded() {
    return this.playerSelf ? this.playerSelf.turnEnd : true
  }

  get isSelected() {
    return this.data.isSelected
  }

  get isVoted() {
    return this.data.isVoted
  }

  proclaimPoliceResult(isMafia: boolean) {
    if (!this.playerSelf) return
    this.game.proclaimPoliceResult(this.playerSelf.id, this.player.id, isMafia)
  }

  proclaimInvestigatorResult(hasWeapon: boolean) {
    if (!this.playerSelf) return
    this.game.proclaimInvestigatorResult(this.playerSelf.id, this.player.id, hasWeapon)
  }

  select() {
    if (this.data.isGallary) return
    
    if (!this.playerSelf) return

    if (this.playerSelf.turnEnd) return

    this.playerSelf.selectedPlayerId = this.playerSelf.selectedPlayerId !== this.player.id
      ? this.player.id
      : ""

    this.playerSelf.updateSelectedPlayerId()
  }

  vote() {
    if (this.data.isGallary) return
    
    if (!this.playerSelf) return
    
    if (this.playerSelf.turnEnd) return
    
    this.playerSelf.votedPlayerId = this.playerSelf.votedPlayerId !== this.player.id
      ? this.player.id
      : ""

    this.playerSelf.updateVotedPlayerId()
  }
}
